import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { MailCheckRequestType, MailCheckResponseType } from '@/types/tools'
import axios from '@/lib/axios'

type ToolsStoreType = {
  checkMailSettings: (params: MailCheckRequestType) => Promise<MailCheckResponseType>
}

const useToolsStore = create<ToolsStoreType>()(
  devtools(() => ({
    checkMailSettings: async (params: MailCheckRequestType) => {
      const { data } = await axios.post('/admin/tools/mail/check', params)
      return data
    }
  }))
)

export default useToolsStore
